/**
 * Returns true when running in a "frontend-only" context (local disco sandbox or preview build)
 */
export function isDevSPA(origin) {
  return origin === 'https://disco-ui.local.rvb.ai' || origin === 'https://preview.reverb.tools';
}
